import React, { useMemo } from 'react';
import { CountryCode } from '@dayetopia/library/types';
import { PageSlice, SliceNewsletterDetails } from '@contracts';
import NewsletterCBDSubscribe from './NewsletterCBDSubscribe';
import NewsletterCustom from './NewsletterCustom';
import NewsletterPPCSubscribe from './NewsletterPPCSubscribe';

interface Props {
  slice: PageSlice;
  country: CountryCode;
}

const NewsletterSubscribe = ({ slice, country }: Props) => {
  const sliceDetails = slice.primary as SliceNewsletterDetails;
  const finalSlice: null | JSX.Element = useMemo(() => {
    const isCustom = sliceDetails?.type === 'custom';

    if (isCustom) {
      return <NewsletterCustom slice={slice} />;
    }

    if (['period-pain', 'period-pain-waitlist', 'hpv-waitlist'].includes(sliceDetails?.type)) {
      return <NewsletterPPCSubscribe slice={slice} country={country} />;
    }
    return <NewsletterCBDSubscribe />;
  }, [slice, country]);

  return finalSlice;
};

export default NewsletterSubscribe;
